import { getPlatformKey } from 'services/Utilities'

// Check if the user is pressing ctrl/cmd + Enter to trigger search
const isSearching = event => {
  const operatingSystem = getPlatformKey()
  return ((operatingSystem === 'WINDOWS' && event.ctrlKey) || (operatingSystem === 'MAC' && event.metaKey)) && event.key === 'Enter'
}

export default isSearching
